import { render, staticRenderFns } from "./contract-row.vue?vue&type=template&id=0ce56841&scoped=true&lang=pug"
import script from "./contract-row.vue?vue&type=script&lang=ts"
export * from "./contract-row.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce56841",
  null
  
)

export default component.exports